document.addEventListener('DOMContentLoaded', function(){
    var seeButton = document.querySelector('#popup-button')
    var popupWindow = document.querySelector('.popup')
    var overlayArea = popupWindow.childNodes[0]

    seeButton.addEventListener('click', function(){
        // popupWindow.style = "display: block;"
        popupWindow.classList.toggle('open')
    })

    overlayArea.addEventListener('click', function(){
        // popupWindow.style = "display: none;"
        popupWindow.classList.toggle('open')
    })

	//XXX: New Form

   //XXX: Check for empty forms fields and get error message 

   var form_error_message = $("#form_error_message"); // error message
   var industrySelectSummary = $("#industry_select summary"); // industry field
   var budgetSelectSummary = $("#budget_select summary"); // expected budget field 
   var nameFormField = $('#main_form_name');
   var emailFormField = $('#main_form_email');
   var messageFormField = $('textarea[name="message"]');
//    var checkbox_input = $(".checkbox-input");
//    var code_input = $("#code_input");

   // This function show error message
   function showErrorMessage(obj){ 
       var errorTargetPosition = obj.offset().top + obj.innerHeight() + 10; // getting position of empty field + this fields height + margin
       form_error_message.offset({top: errorTargetPosition}); // puting position into message block
       form_error_message.css("visibility", "visible"); // making message visible
       setTimeout(function(){ form_error_message.fadeOut("slow", "linear"); }, 2000); // hide message with animation
   }

   // This function check if required fields aren`t empty
   function checkEmpty(){
       form_error_message.css({"visibility" : "hidden", "display": "flex" }); // make error message not visible and display flex

       if (nameFormField.val().trim() == ""){ // if industry field is empty
           showErrorMessage(nameFormField); // show message near this field
           return true; // return error
       }else if (emailFormField.val().trim() == ""){ // if e-mail field is empty or incorrect
           showErrorMessage(emailFormField); // show message near this field
           return true; // return error
       }else if (industrySelectSummary.text().trim() == "* Industry"){ // if industry field is empty
           showErrorMessage(industrySelectSummary); // show message near this field
           return true; // return error
       }else if(budgetSelectSummary.text().trim() == "* Expected Budget"){ // if budget field is empty
           showErrorMessage(budgetSelectSummary); // show message near this field
           return true; // return error
       }else if(messageFormField.val() == ""){ // if message field is empty
           showErrorMessage(messageFormField); // show message near this field
           return true; // return error
       }
    //    else if ( checkbox_input.is(":checked") && (parseInt(code_input.children("input").val().trim().length) != 5)){ // if code field is empty or incorrect
    //         showErrorMessage(code_input); // show message near this field
    //         return true; // return error
    //    }
       else{
           return false; // any errors
       }
   }

//    checkbox_input.on("change", function(){
//         code_input.toggleClass("code-input");
//    });

   function sendForm(event){
       event.preventDefault();

       if(!checkEmpty()){ // check for empty fields
        var form = JSON.stringify($('#form').serializeArray());

        var obj = [form.indexOf('industry'), form.indexOf('industry_description'), form.indexOf('expected_budget'), form.indexOf('message'), form.indexOf('checkbox'), form.indexOf('code')];

        var teststr;
        var elementOfTeststr = '}';
        var result = '"';

        for(var i = 0; i < obj.length; i++){
            teststr = form.slice(obj[i]);
            result += teststr.slice(0, teststr.indexOf(elementOfTeststr)) + '; "';
            // console.log(teststr);
            // console.log(result);
        }

        var fastReady = form.slice(0, obj[0] - 11) + form.slice(obj[3] - 11, form.indexOf('checkbox') - 11) + '"';

        // console.log( 'FAST ' + fastReady);

        result = fastReady.slice(0, fastReady.indexOf('message') + 18) + result.split('"').join("'") + '"}]';

        // console.log( 'RESULT ' + result);

        $.ajax({
            method: 'POST',
            contentType: 'application/json;charset=UTF-8',
            url: 'https://6vnjgxw9wl.execute-api.eu-central-1.amazonaws.com/dev/mail-form',
            //headers: {'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': '*'},
            data: result,
            /*beforeSend: function () {
                $("#form #submit").attr("disabled", true);
            },*/
            success: function() {
                if ( $(window).width() > 768) {
                    $('#formWrap').addClass('form-success');
                }else{
                    $('.contact__back-side').css('display', 'flex');
                    //$("#form #submit").attr("disabled", false);
                }
            }
        });

    }

   }

   var formContainer = $('#form'); // form 

   formContainer.on('submit', function(event){ // submit form event
       sendForm(event);
   });

   // Industry and Expected Budget form elements

   // Textearea if "Other" option is clicked: 

   var otherTextArea = $(".other_scope");

   function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

   function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

   function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

   function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

   function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

   function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

   function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

   // Constructor 
   function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

   // Class for custom select tag
   var detailSelect = function () {

   function detailSelect(container) { // takes a select 

       this.container = document.querySelector(container); // select tag container
       this.options = document.querySelectorAll("".concat(container, " > .select > .select__option")); // select > options
       this.value = this.container.querySelector('summary').textContent; // value of selected item
       this.mouseDown = false; // check if this object is in focus 

       this._addEventListeners(); // all EventListeners

       this._setAria(); // this function make an input element as option to send 

       this.updateValue(); // This function update selected item
   } 

   _createClass(detailSelect, [{ // our Constructor
       key: "_addEventListeners", // add EventListener to select 
       value: function _addEventListeners() {
       var _this = this;

       this.container.addEventListener('toggle', function () {
           if (_this.container.open) return;

           _this.updateValue(); 
       });
       this.container.addEventListener('focusout', function (e) {
           if (_this.mouseDown) return;

           _this.container.removeAttribute('open');
       });

       this.options.forEach(function (opt) { // if option is clicked mouseDown = true
           opt.addEventListener('mousedown', function () {
           _this.mouseDown = true;
           });
           opt.addEventListener('mouseup', function () {  // if option is clicked remove attr open, mouseDown = false
           _this.mouseDown = false;

           _this.container.removeAttribute('open');
           });
       });

       this.container.addEventListener('keyup', function (e) {
           var keycode = e.which;

           var current = _toConsumableArray(_this.options).indexOf(_this.container.querySelector('.active'));

           switch (keycode) {
           case 27:
               // ESC
               _this.container.removeAttribute('open');

               break;

           case 35:
               // END
               e.preventDefault();
               if (!_this.container.open) _this.container.setAttribute('open', '');

               _this.setChecked(_this.options[_this.options.length - 1].querySelector('input'));

               break;

           case 36:
               // HOME
               e.preventDefault();
               if (!_this.container.open) _this.container.setAttribute('open', '');

               _this.setChecked(_this.options[0].querySelector('input'));

               break;

           case 38:
               // UP
               e.preventDefault();
               if (!_this.container.open) _this.container.setAttribute('open', '');

               _this.setChecked(_this.options[current > 0 ? current - 1 : 0].querySelector('input'));

               break;

           case 40:
               // DOWN
               e.preventDefault();
               if (!_this.container.open) _this.container.setAttribute('open', '');

               _this.setChecked(_this.options[current < _this.options.length - 1 ? current + 1 : _this.options.length - 1].querySelector('input'));

               break;
           }
       });
       }
   }, {
       key: "_setAria", // this function make a input element as option to send 
       value: function _setAria() {
       this.container.setAttribute('aria-haspopup', 'listbox');
       var selectBox = this.container.querySelector('.select');
       selectBox.setAttribute('role', 'listbox');
       selectBox.querySelector('[type=radio]').setAttribute('role', 'option');
       }
   }, {
       key: "updateValue", // checked input 
       value: function updateValue(e) {
       var that = this.container.querySelector('input:checked');
       if (!that) return;
       this.setValue(that); // setting value as selected
       }
   }, {
       key: "setChecked",
       value: function setChecked(that) {
       that.checked = true;
       this.setValue(that);
       }
   }, {
       key: "setValue", // this function set new value for selected element
       value: function setValue(that) {
       if (this.value == that.value) return; 
       this.container.querySelector('summary').textContent = that.parentNode.textContent;
       this.container.querySelector('summary').style.color = "#000000"; // making black color if choosed new value
       if (that.parentNode.textContent.trim() == "Other"){ // if new value is "Other" making textarea visible 
           otherTextArea.css("display", "block");
           if ( $(window).width() > 768){ 
                document.getElementById('formWrap').style.height = '120vh';
           }
       }else if(this.container.id == "industry_select"){ 
           otherTextArea.css("display", "none");
           if ( $(window).width() > 768){ 
                document.getElementById('formWrap').style.height = '100vh';
            }
       }
       this.value = that.value;
       this.options.forEach(function (opt) { 
           opt.classList.remove('active'); // other elements couldn`t be active with selected value
       });
       that.parentNode.classList.add('active'); // choosed element will be active 
       this.container.dispatchEvent(new Event('change')); // generate an error if listener is empty 
       }
   }]);

   return detailSelect; // return new select tag
   }();

   //initialization for choose indtustry select  
   var details2 = new detailSelect('#industry_select');

   //initialization for expected budget select  
   var details = new detailSelect('#budget_select');

    
})